/**
 * eligibility.js — Fonction métier centralisée d'éligibilité commerciale.
 * Source unique de vérité pour toute l'application.
 * 
 * Un produit est éligible à l'ajout au bon de commande si et seulement si
 * il possède au moins un distributeur actif ET partenaire commercial (is_partner=true)
 * avec un prix d'achat > 0.
 */

/**
 * Retourne les distributions éligibles (distributeurs partenaires commerciaux actifs).
 * @param {Object} product — Produit avec distributions[] enrichies
 * @returns {Array} distributions éligibles
 */
export const getEligibleDistributors = (product) => {
  if (!product?.distributions) return [];
  return product.distributions.filter(d =>
    d.purchase_price > 0 && d.partner_is_commercial !== false
  );
};

/**
 * Indique si un produit est éligible à l'ajout au bon de commande.
 * @param {Object} product
 * @returns {boolean}
 */
export const isProductEligible = (product) => {
  return getEligibleDistributors(product).length > 0;
};
